import React from "react";

const CardAddButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="flex flex-row  text-gray-200 justify-start items-center gap-2 p-2 bg-gray-600 rounded-xl"
    >
      <img
        src="/add.png"
        alt="cardAdd"
        className="cardAddIcon"
        width="50"
        height="50"
      />
      Өөр картаар төлөх
    </button>
  );
};

export default CardAddButton;
